import { Link } from 'react-router-dom';
import { SCREENS } from '../lib/screenRegistry';
import { ROUTES } from '../lib/classroomRoutes';
import './RegisterSelect.css';

const LOGO = encodeURI('/Assets/logo/mentology- logo.png');

export default function RegisterSelect() {
  return (
    <div className="register-select-page" data-screen-id={SCREENS.MPL02}>
      <div className="register-select-logo-wrap">
        <img
          src={LOGO}
          alt="Mentology"
          className="register-select-logo brand-logo"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      </div>
      <div className="register-select-content">
        <h1 className="section-header register-select-heading">Select Your Registration Pathway</h1>
        <div className="registration-pathway-columns">
          <div className="pathway-column">
            <h2 className="pathway-label">Option A</h2>
            <p className="pathway-desc">Private / Individual enrollment</p>
            <Link to={ROUTES.REGISTRATION_PRIVATE} className="btn-primary">
              Private Registration
            </Link>
          </div>
          <div className="pathway-column">
            <h2 className="pathway-label">Option B</h2>
            <p className="pathway-desc">Enterprise / Organisation enrollment</p>
            <Link to={ROUTES.REGISTRATION_ORGANISATION} className="btn-primary">
              Organisation Registration
            </Link>
          </div>
        </div>
        <div className="button-control-group" style={{ marginTop: '0.75rem' }}>
          <Link to={ROUTES.LANDING} className="btn-primary">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
